import { SUCCESS_SUFFIX, ERROR_SUFFIX } from 'common/constant';
import {
    FETCH_MEDIA_LIBRARY,
    RESET_MEDIA_LIBRARY
} from 'redux/actions/actionTypes';

const initialState = {
    loading: false,
    error: null,
    groups: [],
    count: 0,
    page: 1,
    pageSize: 50,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false,
    filters: {
        groupBy: 'month',
        order: 'newest'
    }
};

const mediaLibraryReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MEDIA_LIBRARY:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_MEDIA_LIBRARY + SUCCESS_SUFFIX: {
            const data = action.payload.data;
            const isFirstPage = data.page === 1;

            return {
                ...state,
                loading: false,
                error: null,
                // If first page, replace groups; otherwise append
                groups: isFirstPage
                    ? data.groups
                    : mergeGroups(state.groups, data.groups),
                count: data.count,
                page: data.page,
                pageSize: data.page_size,
                totalPages: data.total_pages,
                hasNext: data.next !== null,
                hasPrevious: data.previous !== null
            };
        }

        case FETCH_MEDIA_LIBRARY + ERROR_SUFFIX:
            return {
                ...state,
                loading: false,
                error: action.error?.message || 'Failed to load media library'
            };

        case RESET_MEDIA_LIBRARY:
            return initialState;

        default:
            return state;
    }
};

/**
 * Merge new groups into existing groups (for infinite scroll)
 * Groups with the same key are merged, new groups are appended
 */
function mergeGroups(existingGroups, newGroups) {
    const groupMap = new Map();

    // Add existing groups
    existingGroups.forEach((group) => {
        groupMap.set(group.key, { ...group });
    });

    // Merge or add new groups
    newGroups.forEach((group) => {
        if (groupMap.has(group.key)) {
            // Merge media items
            const existing = groupMap.get(group.key);
            existing.media = [...existing.media, ...group.media];
        } else {
            groupMap.set(group.key, { ...group });
        }
    });

    return Array.from(groupMap.values());
}

export default mediaLibraryReducer;
